import {AccountOrganizationRole} from '../../models/organization.model';

export class AccountOrganizationCreateParams {
  accountId: string;
  organizationId: string;
  role?: AccountOrganizationRole;

  constructor(accountId: string, organizationId: string, role?: AccountOrganizationRole) {
    this.accountId = accountId;
    this.organizationId = organizationId;
    this.role = role ?? AccountOrganizationRole.EMPLOYEE;
  }
}
